document.addEventListener('redirect', (e) => {
	if( e.detail.payload && e.detail.payload.url )
		window.location.assign( e.detail.payload.url );
	else
		window.location.reload();
});


